<section class="goBack">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <a [routerLink]="['/news']"><i class="fa fa-long-arrow-left"></i>Back</a>
            </div>
        </div>
    </div>
</section>

<section class="section-pd" *ngIf="article">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="newsBodyContent">
                    <h1>{{ article.title }}</h1>
                    <p class="date">{{ article.date }}</p>
                    <div class="newsImage text-center" *ngIf="article.imageUrl">
                        <img [src]="article.imageUrl" alt="{{ article.imageAlt }}" class="img-fluid" />
                    </div>
                    <p class="mb-40" [innerHTML]="article.subline"></p>
                    <div *ngFor="let section of article.sections" class="mb-40">
                        <h3 *ngIf="section.heading">{{ section.heading }}</h3>
                        <div *ngFor="let paragraph of section.paragraphs" [innerHTML]="paragraph"></div>
                    </div>
                </div>

                
            </div>
        </div>
    </div>
</section>

<!-- If article is not found -->
<div *ngIf="!article">
    <div class="four_zero_four_page section-pd">
        <div class="page_wrap_sections">
            <div class="left_side_secitons">
                <div class="circle_sections">
                    <h2>404</h2>
                    <p>Page Not Found</p>
                </div>
            </div>
            <div class="right_side_secitons">
                <h2>Oh no!</h2>
                <h3>We looked everywhere but could not find the page you are looking for.</h3>
                <p>The link you followed is either outdated, inaccurate, or perhaps you do not have access to this page.</p>
                <button [routerLink]="['/']">Get back Home</button> 
            </div>
        </div>
    </div>
</div>